module.exports = __webpack_public_path__ + "img/1749030619_B2Hk_ar.feb81fa8.png";